const {
    MinimogThemeStyles,
    MinimogThemeScripts
} = window;
class QuickView {
    constructor() {
    
        this.modal = new MinimogTheme.Modal, this.isOpen = !1, addEventDelegate({
            selector: ".m-product-quickview-button",
            handler: (e, i) => {
              e.preventDefault(), this.target = i, this.toggleLoading(this.target, !0);
              const t = i.dataset.productHandle;
              t && this.fetchHtml(t)
            }
       
        }), window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, (() => {
            this.modal && MinimogTheme.ProductQuickView.close()
        }))
    }
    fetchHtml(e) {
    
      console.log(e);
      loadAssetsNew([MinimogThemeStyles.product], "quick-view-assets"), fetchSection("product-quickview", {
          url: `${window.MinimogSettings.base_url}products/${e}`
      }).then((e => {
          this.modalContent = e.querySelector(".m-product-quickview");
          const i = e.querySelector("product-model");
          this.mediaGallery = loadAssetsNew([MinimogThemeScripts.productMedia, MinimogThemeScripts.variantsPicker], "variants-picker", (() => {
              this.modal.appendChild(this.modalContent), this.modal.setWidth("960px"), this.modal.open(), this.toggleLoading(this.target, !1), this.isOpen = !0
          })), i && loadAssetsNew([MinimogThemeScripts.productModel, "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"], "product-model-assets")
         setTimeout(function(){
            initSlider();
          },1000);
      })).catch(console.error)

    }
    close(e) {
        this.modal.close(e), this.isOpen = !1
    }
    toggleLoading(e, i) {
        i ? e.classList.add("m-spinner-loading") : e.classList.remove("m-spinner-loading")
    }
}
MinimogTheme.ProductQuickView = new QuickView;


// $(function() {
//    $('.cstm_box_media').slick({
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           autoplay: false,
//           autoplaySpeed: 2000,
//           infinite: true,
//           prevArrow: '<button class="slide-arrow prev-arrow"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
//           nextArrow: '<button class="slide-arrow next-arrow"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>'
//   });
//   });
  

// quick view filter

function initSlider() {
  var imgTxtBind1 = $('.m-product-quickview--info .cart_drawer_pro:checked').data('imgbind');
  if(typeof(imgTxtBind1) != 'undefined'){
    console.log('Media Slider Initialize --->');
    $('.cstm_box_media').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      infinite: true,
      prevArrow: '<button class="slide-arrow prev-arrow"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
      nextArrow: '<button class="slide-arrow next-arrow"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>'
    });
  } 
}

function variantImage(){
  //console.log('calling variant filter');
  var imgTxtBind = $('.m-product-quickview--info .cart_drawer_pro:checked').data('imgbind');
  if($('.cstm_box_media.slick-initialized').length){
    $('.cstm_box_media').slick('slickUnfilter');
    $('.cstm_box_media').slick('slickFilter', '.'+imgTxtBind);
  }
}
